<mat-toolbar color="primary" class="navbar">
  <span routerLink="/site" class="pointer">Sites</span>
  <span routerLink="/map" class="pointer">Map</span>
  <span routerLink="/scheduler" class="pointer">Scheduler</span>
  <span routerLink="/admin" class="pointer" *ngIf="isAdmin | async">Admin</span>
  <span routerLink="/config" class="pointer">Config</span>
  <span class="right">
    <app-currentuser></app-currentuser>
  </span>
</mat-toolbar>